export default  [

  {
    key: "index",
    label: "#",
    sortable: true
  },

  {
    key: "device",
    label: "Device",
    sortable: true
  },

  {
    key: "geofence",
    label: "Geofence",
    sortable: true
  },

  {
    key: "enter_time",
    label: "Enter",
    sortable: true
  },


  {
    key: "exit_time",
    label: "Exit",
    sortable: true
  },

  {
    key: "duration",
    label: "Duration",
    sortable: true
  },

  {
    key: "distance",
    label: "Distance",
    sortable: true
  },
]